import language from '@/lang/pt-br/index'
import permissions from './permissions'
import blank from '@/mixins/defaults/blank_data.js'
import _options from '@/mixins/defaults/options.js'
import filters from '@/mixins/defaults/filters.js'
import search from '@/mixins/defaults/search.js'

let options = _options(language)

const defaults = {
  language,
  permissions,
  blank,
  options,
  filters,
  search
}

export default defaults
